import * as types from '@store/types'
import request from '@queries'
import VoucherQuery from '@queries/Voucher'
import VouchersQuery from '@queries/Vouchers'
import DeleteVoucher from '@queries/DeleteVoucher'

export const template = {
  voucher: {
    id: null,
    code: '',
    expires: Date.now() / 1000,
    created: Date.now() / 1000,
    company_user: '',


    campaign: {
      title: '',
      value: 0,
      symbol: 'R$',
      important: '',
      partner: {
        logo: '',
        name: '',
        contact: {
          phone: ''
        }
      }
    }
  },

  paginate: {
    to: 0,
    from: 0,
    total: 0,
    per_page: 9,
    current_page: 1,
  }
}

const state = {
  voucher: { ...template.voucher },
  vouchers: [],
  paginate: { ...template.paginate }
}

const getters = {
  [types.VOUCHER]: (state) => state.voucher,
  [types.VOUCHERS]: (state) => state.vouchers,
  [types.VOUCHERS_PAGINATE]: (state) => state.paginate
}

const mutations = {
  [types.VOUCHER]: (state, payload) => {
    state.voucher = { ...template.voucher, ...payload }
  },
  [types.VOUCHERS]: (state, payload) => {
    state.vouchers = payload
  },
  [types.VOUCHERS_PAGINATE]: (state, payload) => {
    state.paginate = payload
  },
  [types.VOUCHER_EXCLUDE]: (state, id) => {
    state.vouchers = state.vouchers.filter(voucher => voucher.id !== id)
  }
}

const actions = {
  [types.VOUCHER]: async ({ commit }, payload) => {
    const response = await request(VoucherQuery, {
      id: payload
    })
    const voucher = response.data.data.voucher || {}
    commit(types.VOUCHER, voucher)
  },

  [types.VOUCHERS]: async ({ commit }, payload) => {
    const response = await request(VouchersQuery, { ...payload })
    const { data: vouchers, ...paginate } = response.data.data.vouchers || {}
    commit(types.VOUCHERS, vouchers)
    commit(types.VOUCHERS_PAGINATE, paginate)
  },

  [types.VOUCHERS_INCREASE]: async ({ commit, getters }, payload) => {
    const {
      to,
      from,
      total,
      per_page: limit,
      current_page: current
    } = getters[types.VOUCHERS_PAGINATE] || {}

    const isValid = total > (from + limit - 1)

    if (!isValid)
      return

    const response = await request(VouchersQuery, {
      page: current + 1,
      ...payload
    })

    const { data, ...paginate } = response.data.data.vouchers || {}
    const vouchers = [ ...getters[types.VOUCHERS], ...data ]

    commit(types.VOUCHERS, vouchers)
    commit(types.VOUCHERS_PAGINATE, paginate)
  },
  [types.VOUCHER_EXCLUDE]: async ({ commit, dispatch }, id) => {
    const payload = { id }

    const { status } = await request(DeleteVoucher, payload)

    if (status) {
      const message = { type: 'success', text: 'Voucher deletado com sucesso!' }

      dispatch(types.FEEDBACK, message)
      commit(types.VOUCHER_EXCLUDE, id)
    } else {
      const message = { type: 'error', text: 'Houve um erro ao deletar o Voucher!' }
      dispatch(types.FEEDBACK, message)
    }
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/voucher.js